import React from "react";
import { useSelector } from "react-redux";
import DataDisplay from "../../../../components/dataDisplay/dataDisplay";

export const DataPoints = () => {
  const sectionStyle = { style: { paddingRight: "80px" } };

  const {
    total,
    averageMinutesToFirstContact,
    averageNumberOfDaysToConversion,
    averageNumberOfDaysToAppointment
  } = useSelector((state) => state.laser.funnelChartData);
  const averageTooltip = useSelector((state) => state.laser.averageTooltip);
  const startFrom = useSelector((state) => state.laser.selectedFilters.startFrom.id);

  return (
    <div data-testid="laser-data-summary" className="section-group flex">
      {total && (
        <DataDisplay
          label={total.label}
          value={total.value}
          url={total.url}
          sectionProps={{ style: { paddingRight: "200px" } }}
          averageProps={{ average: total.average, toolTip: averageTooltip }}
          disableAnimation
        />
      )}

      {averageMinutesToFirstContact && (
        <DataDisplay
          label={averageMinutesToFirstContact.label}
          value={averageMinutesToFirstContact.value}
          type="default"
          sectionProps={sectionStyle}
          averageProps={{ average: averageMinutesToFirstContact.average, toolTip: averageTooltip }}
          disableAnimation
          decimal={averageMinutesToFirstContact.decimal}
        />
      )}

      {startFrom !== "appointments" && averageNumberOfDaysToAppointment ? (
        <DataDisplay
          label={averageNumberOfDaysToAppointment.label}
          value={averageNumberOfDaysToAppointment.value}
          sectionProps={sectionStyle}
          averageProps={{
            average: averageNumberOfDaysToAppointment.average,
            toolTip: averageTooltip
          }}
          type="default"
          decimal={averageNumberOfDaysToAppointment.decimal}
          disableAnimation
        />
      ) : (
        ""
      )}

      {averageNumberOfDaysToConversion === undefined || averageNumberOfDaysToConversion.hide ? (
        ""
      ) : (
        <DataDisplay
          label={averageNumberOfDaysToConversion.label}
          value={averageNumberOfDaysToConversion.value}
          sectionProps={sectionStyle}
          averageProps={{
            average: averageNumberOfDaysToConversion.average,
            toolTip: averageTooltip
          }}
          decimal={averageNumberOfDaysToConversion.decimal}
          type="default"
          disableAnimation
        />
      )}
    </div>
  );
};
